import { Text } from 'components/Text';
import { BarLabelsWrapper } from './styledComponents';

export const BarLabels = ({
  leftSide,
  rightSide
}: {
  leftSide: string;
  rightSide: string;
}) => {
  return (
    <BarLabelsWrapper>
      <Text>{leftSide}</Text>
      <Text>{rightSide}</Text>
    </BarLabelsWrapper>
  );
};
